import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
import { RATING_INPUT_VALUES } from '../constants';
function isRatingInput(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  const isValueInRange = typeof value === 'number' && RATING_INPUT_VALUES.includes(value);
  return fieldType === INPUT_FIELD_TYPES.RATING_INPUT && typeof label === 'string' && (isValueInRange || value === null);
}
function _formatRatingInput(_ref) {
  let {
    field,
    value
  } = _ref;
  if (typeof value !== 'number') {
    return;
  }
  return {
    label: field.view.label,
    value
  };
}
export function formatRatingInput(submission) {
  if (isRatingInput(submission)) {
    return _formatRatingInput(submission);
  }
  return undefined;
}
//# sourceMappingURL=rating-input-preview.js.map